var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.61 29.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c2292e",
    d: "M12.24,19.76A1.8,1.8,0,0,1,14,18.22a1.81,1.81,0,0,1,1.7,1.54l2,8H16.46l-.67-2.63h-3.7l-.65,2.63H10.22ZM15.53,24l-1-4.09c-.08-.34-.25-.58-.57-.58s-.48.22-.57.58l-1,4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2292e",
    d: "M19.36,28.69h1.18a.62.62,0,0,0,.64-.69v-.7a1.57,1.57,0,0,1-1.05.42c-.92,0-1.47-.62-1.47-1.67v-.88c0-1.06.55-1.68,1.46-1.68a1.72,1.72,0,0,1,1.13.51l.05-.4h.6V28a1.22,1.22,0,0,1-1.36,1.33H19.45Zm0-2.76c0,.78.25,1.15.84,1.15a1.55,1.55,0,0,0,.95-.43v-2a1.58,1.58,0,0,0-.95-.48c-.59,0-.84.38-.84,1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2292e",
    d: "M23,25.17a1.59,1.59,0,0,1,1.6-1.68,1.62,1.62,0,0,1,1.62,1.68v.49a.17.17,0,0,1-.17.18H23.67v.3a.93.93,0,0,0,1,1,3.85,3.85,0,0,0,1.2-.22l.15.6a3.94,3.94,0,0,1-1.34.26A1.59,1.59,0,0,1,23,26.14Zm2.5.12v-.16a.9.9,0,1,0-1.79,0v.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2292e",
    d: "M27.2,23.6h.59l.05.41A1.87,1.87,0,0,1,29,23.49a1.24,1.24,0,0,1,1.32,1.4v2.65a.17.17,0,0,1-.17.18h-.55V25c0-.59-.18-.89-.72-.89a1.55,1.55,0,0,0-1,.47v3.12H27.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c2292e",
    d: "M31.64,24.15,31,24.09V23.6h.64V22.28h.72V23.6h1v.55h-1V26.5c0,.5.25.68.58.68a2.77,2.77,0,0,0,.56-.07l.11.61a2.42,2.42,0,0,1-.7.1,1.16,1.16,0,0,1-1.27-1.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b4789",
    d: "M0,18.69c0-.86.51-1.43,1.58-1.43H3v.66H1.59c-.66,0-.85.31-.85.82v.92H2.79v.65h-2v1.06c0,.51.19.82.85.82H3.05v.48a.16.16,0,0,1-.17.17H1.58C.52,22.84,0,22.27,0,21.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b4789",
    d: "M4,22.08a3,3,0,0,0,1,.23c.5,0,.69-.24.69-.58,0-.8-1.79-.55-1.79-1.94a1.23,1.23,0,0,1,1.38-1.17,2.69,2.69,0,0,1,1,.19l-.17.6a2.52,2.52,0,0,0-.81-.15c-.43,0-.65.21-.65.53,0,.75,1.8.58,1.8,1.94,0,.74-.58,1.21-1.43,1.21a3.37,3.37,0,0,1-1.21-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b4789",
    d: "M7.48,18.72h.59l.06.4a1.7,1.7,0,0,1,1.12-.5c.91,0,1.47.61,1.47,1.67v1c0,1-.56,1.66-1.47,1.66A1.65,1.65,0,0,1,8.2,22.5v1.95H7.48Zm.72,3.14a1.59,1.59,0,0,0,1,.45c.59,0,.84-.38.84-1.16v-.73c0-.78-.25-1.16-.84-1.16a1.49,1.49,0,0,0-1,.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b4789",
    d: "M17.22,20.46a1.62,1.62,0,0,1,1.66-1.84,3.88,3.88,0,0,1,1.26.22l-.16.61a3.2,3.2,0,0,0-1.06-.19c-.73,0-1,.53-1,1.26V21c0,.75.24,1.28,1,1.28a3.21,3.21,0,0,0,1.06-.2l.17.61a3.94,3.94,0,0,1-1.27.22,1.62,1.62,0,0,1-1.66-1.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b4789",
    d: "M21,20.3a1.59,1.59,0,0,1,1.61-1.68A1.62,1.62,0,0,1,24.2,20.3v.49A.17.17,0,0,1,24,21H21.69v.31a.93.93,0,0,0,1,1,3.79,3.79,0,0,0,1.19-.22l.15.6a4.18,4.18,0,0,1-1.34.25A1.6,1.6,0,0,1,21,21.27Zm2.51.12v-.16a.9.9,0,1,0-1.79,0v.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c6342c",
    d: "M31.8,11.37,24.86,6.71a.47.47,0,0,0-.79.35l-.3,2.09a2.71,2.71,0,0,0,.73.86l3.1,2.12a2.58,2.58,0,0,1,.93,1.34l1.69,6.9c.06-.28.12-.58.19-.81l1.85-6.94A1.23,1.23,0,0,0,31.8,11.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#2b4789",
    x: 26.01,
    y: 4.48,
    width: 1.36,
    height: 1.37
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#2b4789",
    x: 18.45,
    y: 2.04,
    width: 2.2,
    height: 2.21
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c6342c",
    x: 21.37,
    y: 0,
    width: 1.28,
    height: 1.29
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c6342c",
    x: 24.37,
    y: 2.05,
    width: 1.18,
    height: 1.18
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#c6342c",
    x: 21.96,
    y: 5.59,
    width: 1.18,
    height: 1.18
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b4789",
    d: "M29.26,21.11c.38.25.6.09.49-.35L28,13.67a2.53,2.53,0,0,0-.87-1.26L24,10.3a2.79,2.79,0,0,1-.92-1.25l0-.09a2.59,2.59,0,0,0-.94-1.22l-2-1.28c-.38-.24-.61-.08-.5.36l2.2,8.67a2.42,2.42,0,0,0,.88,1.25Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.11fc958dbd9e0f9752e2f65c9a15d947.svg";
export { ForwardRef as ReactComponent };